import premiumCommonPlugin from "@fullcalendar/premium-common"
import FullCalendar from "@fullcalendar/react"

// The single place FullCalendar is rendered. Loading premium-common here
// registers the schedulerLicenseKey option for every calendar, whether or not
// the caller loads a premium view plugin, so the key is owned in one place and
// is never an unknown option.
export function SagecoolCalendar({
  plugins = [],
  ...props
}: React.CustomComponentPropsWithRef<typeof FullCalendar>) {
  return (
    <FullCalendar
      {...props}
      plugins={[premiumCommonPlugin, ...plugins]}
      schedulerLicenseKey="0051486691-fcs-1749018144"
    />
  )
}
